module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.petId,
      "role": "dialog",
      "aria-labelledby": "modalLabel",
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('img', {
    staticClass: "pet-image",
    staticStyle: {
      "float": "left",
      "margin-right": "5px"
    },
    attrs: {
      "src": _vm.profilePhotoPathComp
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "modal-title",
    staticStyle: {
      "margin-bottom": "0px !important",
      "margin-top": "0px"
    }
  }, [_vm._v(" " + _vm._s(_vm.petComp.Name))]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "margin-bottom": "0px !important",
      "margin-top": "0px"
    }
  }, [_vm._v(" " + _vm._s(_vm.genderToString(_vm.petComp.Gender)) + " " + _vm._s(_vm.petTypeToString(_vm.petComp.PetType)))]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(" " + _vm._s(_vm.ageToString(_vm.petComp.AgeYears, _vm.petComp.AgeMonths)))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body row"
  }, [(_vm.morePics) ? _c('div', {
    staticClass: "photo-images"
  }, [_c('div', _vm._l((_vm.petComp.PetPhotoDtos), function(photo) {
    return _c('div', {
      staticClass: "thumb-wrap",
      attrs: {
        "href": photo.Path,
        "data-fancybox": "pet-photo"
      }
    }, [_c('img', {
      staticClass: "small-images",
      staticStyle: {
        "margin": "2px"
      },
      attrs: {
        "src": photo.Path
      }
    })])
  }))]) : _vm._e(), _vm._v(" "), (_vm.morePics) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.noPetInfoComp == true) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_vm._v("\n           This pet doesn't have optional details, feel free to ask the customer to update.\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('ul', {
    staticStyle: {
      "list-style-type": "none",
      "padding-bottom": "0px !important",
      "margin-bottom": "0px !important",
      "padding": "5px"
    }
  }, [(_vm.petComp.RabiesVaccinated != true && _vm.compUserRole == 'Client') ? _c('li', [_c('i', {
    staticClass: "fa fa-thumbs-o-down"
  }), _vm._v(" Rabies Vaccinated")]) : _vm._e(), _vm._v(" "), (_vm.petComp.RabiesVaccinated == true) ? _c('li', [_c('i', {
    staticClass: "fa fa-thumbs-o-up"
  }), _vm._v(" Rabies Vaccinated")]) : _vm._e(), _vm._v(" "), (_vm.petComp.IsNeuteredOrSpayed != true && _vm.compUserRole == 'Client') ? _c('li', [_c('i', {
    staticClass: "fa fa-thumbs-o-down"
  }), _vm._v(" Neutered or Spayed")]) : _vm._e(), _vm._v(" "), (_vm.petComp.IsNeuteredOrSpayed == true) ? _c('li', [_c('i', {
    staticClass: "fa fa-thumbs-o-up"
  }), _vm._v(" Neutered or Spayed")]) : _vm._e(), _vm._v(" "), (_vm.petComp.TicksOrFleas != true && _vm.compUserRole == 'Client') ? _c('li', [_c('i', {
    staticClass: "fa fa-thumbs-o-down"
  }), _vm._v(" Clean from Ticks & Fleas")]) : _vm._e(), _vm._v(" "), (_vm.petComp.TicksOrFleas == true) ? _c('li', [_c('i', {
    staticClass: "fa fa-thumbs-o-up"
  }), _vm._v(" Clean from Ticks & Fleas")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('ul', {
    staticStyle: {
      "list-style-type": "none",
      "padding-top": "0px !important",
      "margin-top": "0px !important",
      "padding": "5px"
    }
  }, [(_vm.petComp.IsRegisteredwithColar != true && _vm.compUserRole == 'Client') ? _c('li', [_c('i', {
    staticClass: "fa fa-thumbs-o-down"
  }), _vm._v(" Registered with  municipality")]) : _vm._e(), _vm._v(" "), (_vm.petComp.IsRegisteredwithColar == true) ? _c('li', [_c('i', {
    staticClass: "fa fa-thumbs-o-up"
  }), _vm._v(" Registered with municipality")]) : _vm._e(), (_vm.petComp.MicrochipId == null && _vm.compUserRole == 'Client') ? _c('li', [_c('i', {
    staticClass: "fa fa-thumbs-o-down"
  }), _vm._v(" MicrochipId")]) : _vm._e(), _vm._v(" "), (_vm.petComp.MicrochipId) ? _c('li', [_c('i', {
    staticClass: "fa fa-thumbs-o-up"
  }), _vm._v(" MicrochipId: " + _vm._s(_vm.petComp.MicrochipId))]) : _vm._e(), _vm._v(" "), (_vm.petComp.PreferredVet) ? _c('li', [_vm._v("Preferred Vet in case of emergency:  " + _vm._s(_vm.petComp.PreferredVet))]) : _vm._e(), _vm._v(" "), (_vm.petComp.Remarks) ? _c('li', [_vm._v("Remarks:  " + _vm._s(_vm.petComp.Remarks))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.compUserRole == 'Client') ? _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.goUpdatePet(_vm.petComp)
      }
    }
  }, [_vm._v("Update Info")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1d102b2a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SharedComponents/PetDetailsView.vue
// module id = 612
// module chunks = 2